import { axiosClient } from './axiosClient.service'

export function onApiError(cb: (message: string) => void) {
  axiosClient.interceptors.response.use(
    (response) => response,
    (error) => {
      const SERVER_ERROR_STATUS_CODE = 500
      if (error.response.status >= SERVER_ERROR_STATUS_CODE) {
        cb(error.message)
      }

      return Promise.reject(error)
    },
  )
}
